import $ from "jquery";

import GeneralKenticoForm from './form-general-kentico';

class MoreInfoForm extends GeneralKenticoForm {
    constructor(config) {
        super(config);
        this.getPostDataCallback = this.addPostData.bind(this);
        this.config = config;
    }

    addPostData(postData) {
        let communityNames = [];
        const guidClassname = this.config.additionalCommunities.replace(/\./g, '');  // contains a list of guids to submit with the form
        const elements = Array.from(document.getElementsByClassName(guidClassname));
        const guids = elements.flatMap(element => ($(element).attr('value') || '').split(';'));
    
        if (!this.stateRegionCommunitySelect) {
            // do the lookup in the lookup element. In the collapsed version of the more info, this.stateRegionCommunitySelect is null
            const additionalCommunityLookupClassname = this.config.additionalCommunityLookup.replace(/\./g, '').split(';');
            const lookupElements = Array.from(document.getElementsByClassName(additionalCommunityLookupClassname));
            communityNames = lookupElements.flatMap(element => {
                const mappings = ($(element).attr('value') || '').split(';');
                return mappings.map(item => {
                    const [name, guid] = item.split('|');
                    if (guids.includes(guid)) {
                        return name;
                    }
                }).filter(Boolean);
            });
        } else {
            communityNames = guids.reduce((names, guid) => {
                const community = this.stateRegionCommunitySelect.getCommunityData(guid);
                if (community && community.communityName) {
                    names.push(community.communityName);
                }
                return names;
            }, []);
        }
    
        // Add all community names to the postData.Communities array
        if (!postData.Communities) {
            postData.Communities = [];
        }
        postData.Communities.push(...communityNames);
    
        // Remove duplicates from the community names array
        const uniqueCommunityNames = [];
        for (const name of postData.Communities) {
            if (!uniqueCommunityNames.includes(name)) {
                uniqueCommunityNames.push(name);
            }
        }
    
        // Update postData.Communities with unique community names
        postData.Communities = uniqueCommunityNames;
        return postData;
    }
}

export { MoreInfoForm as default }
